import styled from 'styled-components';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import VizExLink from 'visitor-ui-component-library/link/VizExLink';
import { PlayerErrorTypes } from '../constants';
import ModalOverlay from './ModalOverlay';
import { shouldIgnorerPlayerErrorsForUserAgent } from 'video-embed/utils/env';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledError = styled.div.withConfig({
  displayName: "PlayerError__StyledError",
  componentId: "sc-1m2glas-0"
})(["display:flex;flex-direction:column;height:100%;text-align:center;justify-content:center;color:white;"]);
const PlayerError = ({
  appError,
  videoFetchError,
  videoJsError,
  hasPlaybackStarted
}) => {
  let errorKey = 'generic';
  let navMarkerKey = 'GENERIC_PLAYER_ERROR';
  if (shouldIgnorerPlayerErrorsForUserAgent()) {
    navMarkerKey = 'CRAWLER_ERROR';
  } else if (videoFetchError) {
    if (videoFetchError.status === 404 || videoFetchError.status === 204) {
      errorKey = PlayerErrorTypes.VIDEO_NOT_FOUND;
      navMarkerKey = 'VIDEO_NOT_FOUND';
    } else if (videoFetchError.status === 488) {
      errorKey = PlayerErrorTypes.VIDEO_NOT_FOUND;
      navMarkerKey = 'VIDEO_HUBLET_MISMATCH';
    } else if (videoFetchError.status >= 401 && videoFetchError.status <= 403) {
      errorKey = PlayerErrorTypes.UNAUTHORIZED;
      navMarkerKey = 'VIDEO_NOT_AUTHORIZED';
    } else if (videoFetchError.status === 0) {
      navMarkerKey = 'VIDEO_FETCH_TIMEOUT';
      if (videoFetchError.errorCode === 'ABORT') {
        navMarkerKey = 'VIDEO_FETCH_ABORTED';
      }
    } else {
      navMarkerKey = 'VIDEO_FETCH_FAILED_OTHER';
    }
  } else if (appError) {
    errorKey = appError;
    if (appError === PlayerErrorTypes.UNSUPPORTED_EMBED) {
      navMarkerKey = 'UNSUPPORTED_EMBED';
    } else if (appError === PlayerErrorTypes.VIDEO_NOT_FOUND) {
      navMarkerKey = 'VIDEO_NOT_FOUND';
    }
  } else if (videoJsError) {
    navMarkerKey = hasPlaybackStarted ? 'VIDEOJS_PLAYBACK_ERROR' : 'VIDEOJS_LOAD_ERROR';
  }
  return /*#__PURE__*/_jsxs(ModalOverlay, {
    allowClose: false,
    use: "lightbox",
    children: [/*#__PURE__*/_jsxs(StyledError, {
      children: [/*#__PURE__*/_jsx("h2", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `videoPlayer.errors.${errorKey}.heading`,
          "data-error-type": errorKey
        })
      }), errorKey === 'generic' && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(VizExLink, {
          "data-test-id": "player-error-try-again",
          onClick: () => window.location.reload(),
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "videoPlayer.errors.refreshLink"
          })
        })
      }), errorKey === 'UNSUPPORTED_EMBED' && /*#__PURE__*/_jsx("p", {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: `videoPlayer.errors.UNSUPPORTED_EMBED.extra`
        })
      })]
    }), /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerKey
    })]
  });
};
export default PlayerError;